import { motion } from "framer-motion";
import { Award, Building2, Map } from "lucide-react";

const ITEMS = [
  {
    icon: Award,
    title: "Premio IFAI 2021",
    desc: "Reconocimiento internacional en la categoría de tensoestructuras otorgado por la Industrial Fabrics Association International.",
  },
  {
    icon: Building2,
    title: "+20 años de trayectoria",
    desc: "Más de dos décadas instalando arquitectura textil para corporativos, instituciones educativas y proyectos residenciales premium en México y Latinoamérica.",
  },
  {
    icon: Map,
    title: "Cobertura nacional",
    desc: "+30 ciudades con proyectos entregados, equipo propio de instalación y centro de fabricación en Monterrey.",
  },
];

export default function SocialProof() {
  return (
    <section data-testid="social-proof-section" className="bg-[#F2F4ED] text-[#1F2937] section-pad">
      <div className="container-tight">
        <div className="flex items-center gap-3 mb-4">
          <span className="divider-accent" />
          <span className="kicker">Reconocimientos</span>
        </div>
        <h2 className="font-display font-black tracking-tightest text-4xl md:text-5xl leading-[0.95] max-w-3xl">
          Respaldados por la <span className="text-accent">industria</span>.
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#F0F4DC]">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-eclipse p-8 lg:p-10 border-t-2 border-transparent hover:border-accent transition-colors"
                data-testid={`social-proof-${i}`}
              >
                <div className="w-14 h-14 grid place-items-center border border-accent/50 text-accent">
                  <Icon className="w-7 h-7" />
                </div>
                <h3 className="mt-6 font-display font-black text-2xl text-[#1F2937]">{item.title}</h3>
                <p className="mt-3 text-[#1F2937]/65 text-[14px] leading-relaxed">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
